import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import { Loading } from '@common/components/loading';

import { TextEdit } from '../../../text-edit';
import { BackBtn } from '../../../back-btn';

import { useCousinPageController } from './cousin-page.controller';
import { CousinPageProps } from './cousin-page.types';
import { Subtitle } from '../../../subtitle';
import { TextEditor } from '../../../text-editor';

import './cousin-page.styles.scss';

export const CousinPage: React.FC<CousinPageProps> = (props) => {
  const { cachedData, onGoBack, errors } = props;

  const {
    loadingPage,
    handlePageNameChange,
    handlePageDescriptionChange,
  } = useCousinPageController(props);
  
  if (loadingPage || !cachedData) {
    return (
      <div className="FhqDesignToolQuestionnaireDesignerPage">
        <Loading size={20} margin="20px" />
      </div>
    );
  }

  return (
    <div className="FhqDesignToolQuestionnaireDesignerCousinPage">
      <BackBtn className="FhqDesignToolQuestionnaireDesignerCousinPage__back-btn" onClick={onGoBack} />
      <TextEdit 
        errors={errors?.properties?.title}
        required
        metadata={{
          description: 'page-name',
        }}
        value={cachedData.title}
        onChange={handlePageNameChange}
      />
      <Subtitle type="chip" text={I18n.t('Aunts/Uncles')} />
      <TextEditor
        metadata={{
          description: 'page-description',
        }}
        label={I18n.t('Page Description')}
        value={cachedData.description ?? ''}
        onChange={handlePageDescriptionChange}
      />
    </div>
  );
};